export default __webpack_public_path__ + "static/media/peachtreehillsplace.9f416311.png";